import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProfileView, ProfileBackground } from "../components/ProfileView";
import { Loader } from "../components/ProtectedRoute";

export default function PublicProfile() {
  const { username } = useParams();
  const [p, setP] = useState(null);
  const [missing, setMissing] = useState(false);
  const [entered, setEntered] = useState(false);
  const counted = useRef(false);

  useEffect(() => {
    api.get(`/profiles/${username}`).then(({ data }) => {
      setP(data);
      document.title = `@${data.username} · visc.lol`;
      if (!counted.current) {
        counted.current = true;
        api.post(`/profiles/${username}/view`).then(({ data: v }) => setP((x) => ({ ...x, views: v.views }))).catch(() => {});
      }
    }).catch(() => setMissing(true));
  }, [username]);

  if (missing) return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#080808] px-6 text-center" data-testid="profile-not-found">
      <div className="font-display text-7xl font-extrabold grad-text">404</div>
      <p className="text-zinc-400">visc.lol/<span className="text-white">{username}</span> is unclaimed.</p>
      <Link to={`/register?u=${username}`} className="btn-pink" data-testid="profile-claim-button">claim it</Link>
    </div>
  );
  if (!p) return <Loader />;

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#080808]">
      <ProfileBackground p={p} />
      {!entered && (
        <button data-testid="profile-click-to-enter-button" onClick={() => setEntered(true)} className="fixed inset-0 z-50 flex cursor-pointer items-center justify-center bg-black/70 backdrop-blur-2xl transition-opacity">
          <span className="font-display text-lg font-semibold tracking-wide text-white animate-pulse-glow" style={{ textShadow: `0 0 24px ${p.accent_color}` }}>click to enter</span>
        </button>
      )}
      <main className="relative z-10 flex min-h-screen items-center justify-center px-5 py-16">
        {entered && <ProfileView profile={p} play />}
      </main>
      <Link to="/" className="fixed bottom-4 left-1/2 z-20 -translate-x-1/2 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30 transition-colors hover:text-white/70" data-testid="profile-powered-by">visc.lol</Link>
    </div>
  );
}
